import { render, staticRenderFns } from "./EventSingle.vue?vue&type=template&id=1e42d684&scoped=true&"
import script from "./EventSingle.vue?vue&type=script&lang=js&"
export * from "./EventSingle.vue?vue&type=script&lang=js&"
import style0 from "./EventSingle.vue?vue&type=style&index=0&id=1e42d684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e42d684",
  null
  
)

export default component.exports